import React from 'react'

const NotFound = () => {
  return (
    <div>
            This page doesnt exist..
    </div>
  )
}

export default NotFound